import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import {
  getUserDisplayName,
  haveValue,
  toast,
  validatePhoneNumber,
} from "../../../helper/common";
import { useCookies } from "react-cookie";
import ProfileTable from "../../../components/Profiles/ProfilesTable";
import AddAgentModal from "./AddAgentModal";
import SkorDefaultLoader from "../../../assets/img/skorDefaultLoader.gif";
import socket from "../../../socket";
import ShareWorkspaceModal from "../../../components/Workspace/ShareWorkspaceModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../../Utils/workspaceRoleCapabilities";
import DataLoadedError from "../../../components/ErrorModal/DataLoadedError";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import copy from "copy-to-clipboard";
import { FaRegCopy } from "react-icons/fa6";
import { PhoneInput } from "react-international-phone";

function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const ProfileRequestNew = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const authContext = useContext(AuthContext);
  const {
    user,
    userType,
    loadMyNotifications,
    loadUserTenant,
    setErrorDataLoading,
    errorDataLoading,
  } = authContext;

  const tenantContext = useContext(TenantContext);
  const { shareProfile } = tenantContext;

  const landLordContext = useContext(LandLordContext);
  const {
    loadAgencyProfile,
    loadProfilesLandlord,
    properties,
    loadProperties,
    getTanentData,
    isCustomClientWorkspace,
    sendInvitationToTenant,
    deaWorkspace,
  } = landLordContext;

  const [rentPercentage, setRentPercentage] = useState(
    user?.rent_percentage ?? 1
  );
  const [rentDoc, setRentDoc] = useState("current_annual_income");
  const [bulkShareModal, setBulkShareModal] = useState(false);

  const queryParameters = new URLSearchParams(window.location.search);
  const svgRef = useRef();
  const location = useLocation();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerName, setSharerName] = useState(null);
  const [sharerPhone, setSharePhone] = useState("");

  //toggling between full and basic profile
  const [loading, setLoading] = useState(false);

  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);
  const [effortRateModal, setEffortRateModal] = useState(false);
  const [currentWorkspace, setCurrentWorkspace] = useState("");

  const [filters, setFilters] = useState({
    createdAt: "desc",
    myScore: "",
  });

  const [profiles, setProfiles] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(15);
  const [total, setTotal] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [tanentData, setTanentData] = useState([]);
  const loadingRef = useRef(false);
  const importInitiatedRef = useRef(false);
  const prevWorkspaceIdRef = useRef(null);
  const loadDataRef = useRef(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [showInviteTenantModel, setShowInviteTenantModel] = useState(false);

  const [assignLLModal, setAssignLLModal] = useState({
    tenant_id: null,
    openModal: false,
  });
  const [tabSelected, setTabSelected] = useState("all");

  const [effortRatePecentage, setEffortRatePecentage] =
    useState(rentPercentage);

  const handleDownloadQR = useCallback(() => {
    const svg = svgRef.current.innerHTML;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    downloadBlob(blob, `myimage.svg`);
  }, []);

  const handlecopyUrl = () => {
    copy(
      user?.role === "landlord" &&
        user?.current_workspace?.customLinkSlug &&
        user?.current_workspace?.customLinkEnabled === true
        ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
        : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
    );
    toast.success(_t("linkCopied"));
  };

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const sendInvitationViaPhone = async (e) => {
    e.preventDefault();
    const validate = validatePhoneNumber(sharerPhone);
    if (!validate.isValid) {
      toast.error(validate.message);
      return false;
    } else {
      try {
        const response = await sendInvitationToTenant({
          type: "phone",
          name: sharerName,
          phone: sharerPhone,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharePhone("");
        setShowPhoneModal(false);
      }
    }
  };

  useEffect(() => {
    let userid = localStorage.getItem("saveduserid");
    if (haveValue(user?._id) || haveValue(userid)) {
      useeffectfunc();
    }
    if (haveValue(userid)) {
      loadProperties(userid);
    }
  }, [filters]);

  useEffect(() => {
    fetchTanentData();
    if (haveValue(user?.rent_percentage)) {
      setRentPercentage(user?.rent_percentage);
      setEffortRatePecentage(user?.rent_percentage);
    }
    if (haveValue(user?.rent_from)) {
      setRentDoc(user?.rent_from);
    }
    if (haveValue(user?._id)) {
      loadProperties(user?._id);
    }
    const workspaceFromUrl = user?.workspaceIds?.filter(
      (val) => val?.uuid === workspaceId
    );
    setCurrentWorkspace(workspaceFromUrl?.[0]);
    isCustomClientWorkspace(user?.email);

    if (workspaceId !== prevWorkspaceIdRef.current) {
      setProfiles([]);
      setPage(1);
      setTotal(0);
      setSearchVal("");
      setTabSelected("all");
      prevWorkspaceIdRef.current = workspaceId;
      loadingRef.current = false;
      loadData(1);
    } else {
      useeffectfunc();
    }
  }, [user, workspaceId]);

  useEffect(() => {
    socket.on("forensic_completed", (data) => {
      loadData(1, searchVal);
    });

    return () => socket.off("forensic_completed");
  }, [user]);

  const useeffectfunc = async () => {
    const sharedProfileLink = queryParameters.get("sharedProfileLink");
    const navigateTo = queryParameters.get("navigateTo");
    if (haveValue(navigateTo)) {
      navigate(`/${navigateTo}`);
    }
    if (haveValue(sharedProfileLink)) {
      // await importProfileRedirect();
    } else {
      loadData();
    }
  };

  const fetchTanentData = async () => {
    try {
      const tanentData = await getTanentData();
      const dataArray = Array.isArray(tanentData?.data) ? tanentData.data : [];

      const updatedData = dataArray.map((item) => {
        const application = item?.application_id;
        if (application.participants.length > 0) {
          const participants = application.participants || [];
          const owner = participants.find(
            (p) => p?.id === application?.created_by
          );
          return {
            label: item?.application_id?.title,
            share_profile_id: item?._id,
            value: item?.tenant_id?._id,
            sub_val: `with ${participants.length - 1} other tenants`,
            applicationId: item?.application_id?._id,
            application: item?.application_id,
            isApplication: true,
          };
        }
        return {
          label: getUserDisplayName(item?.tenant_id),
          share_profile_id: item?._id,
          value: item?.tenant_id?._id,
          sub_val: item?.tenant_id?.email,
        };
      });

      setTanentData(updatedData);
    } catch (error) {
      console.error("Error fetching tenant data:", error);
    }
  };

  const loadData = async (requestedPage = page, search = searchVal, filter) => {
    if (loadingRef.current && !search) return;
    loadingRef.current = true;

    if (requestedPage === 1) {
      setLoading(true);
    } else {
      setIsLoadingMore(true);
    }
    try {
      let userid = localStorage.getItem("saveduserid");

      let response;

      // if (user?.isParentLL && haveValue(user?.agency_id)) {
      //   response = await loadAgencyProfile(
      //     user?.agency_id?._id,
      //     requestedPage,
      //     limit,
      //     search
      //   );
      // } else

      if (user?._id) {
        response = await loadProfilesLandlord(user?._id, "full", {
          searchVal: search,
          page: requestedPage,
          limit,
          filter: tabSelected,
        });
      }

      if (!response) {
        return;
      }

      const { data, total: newTotal } = response;

      setTotal(newTotal);
      setPage(requestedPage);

      setProfiles((prev) => (requestedPage === 1 ? data : [...prev, ...data]));
      loadMyNotifications(userid, userType);
    } catch (err) {
      setErrorDataLoading(true);
    } finally {
      setLoading(false);
      setIsLoadingMore(false);
      loadingRef.current = false;
    }
  };

  loadDataRef.current = loadData;

  useEffect(() => {
    const handler = () => {
      loadingRef.current = false;
      loadDataRef.current(1);
    };
    window.addEventListener("profiles-refresh", handler);
    return () => window.removeEventListener("profiles-refresh", handler);
  }, []);

  const refreshWorkspaceFunc = () => {
    loadData();
    fetchTanentData();
  };

  useEffect(() => {
    importProfileRedirect();
  }, [user]);

  const importProfileRedirect = async () => {
    if (importInitiatedRef.current) return;

    let userid = localStorage.getItem("saveduserid");
    const sharedProfileLink = cookies.sharedProfileLink;

    if (haveValue(sharedProfileLink)) {
      importInitiatedRef.current = true;
      const shareProfileResponse = await shareProfile(
        sharedProfileLink,
        userid,
        "null",
        "full",
        { shareType: "tLink" }
      );
      removeCookie("sharedProfileLink", { maxAge: 1800 });

      if (shareProfileResponse?.success) {
        toast.success(_t("profileImported"));
      } else if (shareProfileResponse?.key === "profile-not-found") {
        toast.error(shareProfileResponse?.errormsg ?? _t("failedToGetProfile"));
        return;
      } else if (shareProfileResponse?.key === "access-cancelled") {
        toast.error(
          _t(shareProfileResponse?.errormsg) ?? _t("failedToGetProfile")
        );
        return;
      } else {
        toast.error(shareProfileResponse?.errormsg ?? _t("failedToGetProfile"));
        return;
      }
      navigate(
        `/${workspaceId}/profile-property?sharedprofileid=${shareProfileResponse?.sharedProfileId}`,
        {
          state: { from: location.pathname + location.search },
        }
      );
    }
  };

  const searchTenant = (e) => {
    const q = e.target.value;
    setSearchVal(q);
    setPage(1);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setProfiles([]);
      loadData(1, searchVal, tabSelected);
    }, 200);

    return () => clearTimeout(delayDebounceFn);
  }, [searchVal, tabSelected]);

  const checkSalary = (user) => {
    if (haveValue(user?.gurantor_id) && haveValue(user?.gurantor_id?._id)) {
      if (user?.gurantor_id?.algoanIncome) {
        let monthlyIncome = parseInt(
          user?.gurantor_id?.algoanIncome?.monthlyAmount
        );

        let userIncome = parseInt(
          haveValue(user?.gurantor_id?.current_annual_income)
            ? user?.gurantor_id?.current_annual_income
            : 0
        );
        let salaryMatch = Math.round((monthlyIncome / userIncome) * 100);

        return {
          matched: salaryMatch,
          salary: monthlyIncome,
        };
      }
    } else {
      if (user?.algoanIncome) {
        let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);

        let userIncome = parseInt(
          haveValue(user.current_annual_income) ? user.current_annual_income : 0
        );
        let salaryMatch = Math.round((monthlyIncome / userIncome) * 100);
        return {
          matched: salaryMatch,
          salary: monthlyIncome,
        };
      }
    }
  };

  const openAssignLLModal = (tenant_id) => {
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: tenant_id,
      openModal: true,
    }));
  };
  const handleCloseModal = () => {
    loadData();
    setAssignLLModal((prev) => ({
      ...prev,
      tenant_id: null,
      openModal: false,
    }));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 500 &&
        !loadingRef.current &&
        profiles.length < total
      ) {
        loadData(page + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, total, profiles]);

  return (
    <>
      <div
        className="main-page-wrapper mb-4 position-relative profileRequestWrapper"
        onClick={() => setEffortRateModal(false)}
      >
        <div className="profile-page marless mobile-max-less mobile-max-lesshead">
          <div className="number-properties numberProperties">
            <h2>{_t("tenants")}</h2>
            <div className="d-flex align-items-center propertySearchWrapper">
              {userType === "landlord" &&
              WORKSPACE_ROLES_CAPABILITIES?.tenants?.inviteTenant?.includes(
                user?.current_workspace_role
              ) ? (
                <div className="shareQr">
                  <a
                    className="addGuarantorButton d-flex align-items-center addPropertyButton bulkShareButton addNewProperty invite-tenant-button"
                    href={undefined}
                    onClick={() => setShowInviteTenantModel(true)}
                  >
                    <img
                      className="invite-tenant-icon"
                      src="/images/invite-tenant-icon.svg"
                      alt=""
                    />
                    {_t("requestProfile")}
                  </a>
                </div>
              ) : null}
              {WORKSPACE_ROLES_CAPABILITIES?.tenants?.share?.includes(
                user?.current_workspace_role
              ) &&
                user?.current_workspace?._id?.toString() ===
                  currentWorkspace?._id?.toString() && (
                  <button
                    className="bulkShareButton tutorial-tenant-share-button manageProperties"
                    onClick={() => setBulkShareModal(true)}
                  >
                    <img src="/images/bulkShareIcon.svg" />
                    {_t("bulkShare")}
                  </button>
                )}
            </div>
          </div>
        </div>
        <div className="">
          {errorDataLoading ? (
            <DataLoadedError />
          ) : (
            <div className="profile-table-card">
              <div className="profile-table-header">
                <div className="tabButtonWrapper  w-100 d-flex align-items-center justify-content-between">
                  <div className="d-flex custom-gap-2">
                    {["all", "unassigned", "assigned", "renting"].map(
                      (btnText) => (
                        <div
                          onClick={() => setTabSelected(btnText)}
                          className={`d-flex align-items-center justify-content-center tabButton cursor-pointer ${
                            btnText === tabSelected ? "tabButtonSelected" : ""
                          }`}
                          key={btnText}
                        >
                          <p>{_t(btnText)}</p>
                        </div>
                      )
                    )}
                  </div>
                  <div className="Search-bar searchbar_cls search-bar">
                    <div className="search_bar_edit">
                      <a href="#">
                        <img
                          src="/images/search-icon-grey.svg"
                          alt=""
                          className="searchIcon"
                        />
                      </a>
                      <input
                        type="text"
                        className="custom-input mb-0 input01"
                        onChange={searchTenant}
                        value={searchVal}
                        placeholder={_t("search")}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tabs-item d-block p-0">
                {loading ? (
                  <div className="defaultSkorLoaderParent mt-3">
                    <img
                      src={SkorDefaultLoader}
                      className="defaultSkorLoaderSmall"
                      alt="Example"
                    />
                  </div>
                ) : (
                  <>
                    <ProfileTable
                      profile={profiles}
                      properties={properties}
                      loadData={loadData}
                      user={user}
                      openAssignLLModal={openAssignLLModal}
                      checkSalary={checkSalary}
                      rentPercentage={rentPercentage}
                      rentDoc={rentDoc}
                      deaWorkspace={deaWorkspace}
                    />
                    {isLoadingMore ? (
                      <div className="defaultSkorLoaderParent mt-3">
                        <img
                          src={SkorDefaultLoader}
                          className="defaultSkorLoaderSmall"
                          alt="Example"
                        />
                      </div>
                    ) : (
                      profiles?.length === 0 && (
                        <div className="defaultSkorLoaderParent mt-3">
                          {_t(
                            "noProfilesFound",
                            "Used text if there is no profile in landlord's tenant profile"
                          )}
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {assignLLModal.openModal && (
        <AddAgentModal
          tenant_id={assignLLModal.tenant_id}
          openModal={assignLLModal.openModal}
          handleCloseModal={handleCloseModal}
        />
      )}

      {bulkShareModal && (
        <ShareWorkspaceModal
          isOpen={bulkShareModal}
          onClose={() => setBulkShareModal(false)}
          wholeData={tanentData}
          dataType={"tenants"}
          refreshFunc={refreshWorkspaceFunc}
          isFromTenantProfile
        />
      )}
      <Modal
        show={showInviteTenantModel}
        onHide={(e) => setShowInviteTenantModel(false)}
        centered
        className="newmodalui max-w-lg wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("yourProfileQR")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center justify-content-center text-grey-color">
            <p>{_t("shareThisLinkSoThatTenantProfileWillBeLinkedTo")}</p>
            <p className="d-flex align-items-center custom-gap-1">
              <span
                className="d-flex align-items-center custom-gap-1"
                style={{ fontWeight: 600 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className="inviteTenantHomeSvg"
                >
                  <path
                    d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                    fill="#253837"
                  />
                </svg>
                {user?.current_workspace?.name}
              </span>{" "}
              {_t("workspaceAutomatically")}
            </p>
          </div>
          <div className="qr-code-div qrcode-copy" ref={svgRef}>
            <QRCode
              id="qr_code_image"
              value={
                user?.role === "landlord" &&
                user?.current_workspace?.customLinkSlug &&
                user?.current_workspace?.customLinkEnabled === true
                  ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
                  : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
              }
            />
          </div>
          <div className="qr-link-copi share-and-copy-div">
            <input
              type="text"
              disabled
              value={
                user?.role === "landlord" &&
                user?.current_workspace?.customLinkSlug &&
                user?.current_workspace?.customLinkEnabled === true
                  ? `${window.location.protocol}//${window.location.host}/oauth/${user?.current_workspace?.customLinkSlug}`
                  : `${`${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}_${workspaceId}`}`
              }
            />
            <button type="button" onClick={handlecopyUrl}>
              <FaRegCopy />
              {_t("copyURL")}
            </button>
          </div>
          {user?.current_workspace?.customLinkEnabled && (
            <div className="d-flex align-items-center justify-content-end custom-domain-link-wrapper">
              {/* <div className="custom-domain-link">
                <span className="dot" />
                <span>{_t("usingCustomDomain")}: </span>
                <span>{`${window.location.host}/oauth/`}</span>
                <span>{user?.current_workspace?.customLinkSlug}</span>
              </div> */}
              <div
                className="underline cursor-pointer editInvitationSettingLink"
                onClick={() => {
                  setShowInviteTenantModel(false);

                  const params = new URLSearchParams(location.search);
                  params.set("openEditableTab", "invitations");

                  navigate({
                    pathname: location.pathname,
                    search: `?${params.toString()}`,
                  });
                }}
              >
                {_t("editInvitationSettings")}
              </div>
            </div>
          )}
          <div className="d-flex justify-content-center gap-2 align-items-center inviteButtonWrapper mt-20px">
            <button
              type="button"
              onClick={() => {
                setShowEmailModal(true);
                setShowInviteTenantModel(false);
              }}
              className="btn btngreen"
            >
              {_t("shareViaEmail", "Landlord side in tenant profile section")}
            </button>
            <button
              type="button"
              onClick={() => {
                setShowPhoneModal(true);
                setShowInviteTenantModel(false);
              }}
              className="btn btngreen"
            >
              {_t("shareViaPhone", "Landlord side in tenant profile section")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEmailModal}
        onHide={(e) => setShowEmailModal(false)}
        centered
        className="newmodalui max-w-lg wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("email")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="qr-link-copi"> */}
          <form
            onSubmit={sendInvitationViaEmail}
            className="d-flex flex-wrap mt-5 justify-content-center"
          >
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("name")}
                onBeforeInput={(e) => {
                  const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
                  if (!isValidChar) e.preventDefault();
                }}
              />
            </div>
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="email"
                onChange={(e) => {
                  setSharerEmail(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("email")}
                onBeforeInput={(e) => {
                  if (!e.data) return; // allow delete, etc.

                  const value = e.data;

                  // Allow full pasted string
                  const isValid = /^[a-z0-9._%+-@]+$/.test(value);

                  if (!isValid) {
                    e.preventDefault();
                    return;
                  }

                  // Prevent multiple @ (handle paste too)
                  const existingValue = e.target.value;
                  const totalAtCount =
                    (existingValue + value).split("@").length - 1;

                  if (totalAtCount > 1) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className="col-12 mt-3  d-flex justify-content-center">
              <button type="submit" className="btn btngreen">
                {_t("sendInvitation")}
              </button>
            </div>
          </form>
          {/* </div> */}
        </Modal.Body>
      </Modal>
      <Modal
        show={showPhoneModal}
        onHide={(e) => setShowPhoneModal(false)}
        centered
        className="newmodalui max-w-lg wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{_t("phone")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={sendInvitationViaPhone}
            className="d-flex flex-wrap mt-5 justify-content-center"
          >
            <div className="form-group col-6 px-1 bodyContentset">
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("name")}
              />
            </div>
            <div className="form-group col-6 px-1 bodyContentset">
              <PhoneInput
                className="custom-input phone_input_info send-invite-input"
                international
                defaultCountry={"es"}
                value={sharerPhone}
                onChange={(e) => setSharePhone(e?.replace("+", "") || "")}
              />
            </div>
            <div className="col-12 mt-3 d-flex justify-content-center">
              <button type="submit" className="btn btngreen">
                {_t("sendInvitation")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProfileRequestNew;
